export var SessionClientType;
(function (SessionClientType) {
    SessionClientType["Browser"] = "Browser";
    SessionClientType["iOS"] = "iOS";
    SessionClientType["Android"] = "Android";
})(SessionClientType || (SessionClientType = {}));
export var SessionLoginMethod;
(function (SessionLoginMethod) {
    SessionLoginMethod["Password"] = "Password";
    SessionLoginMethod["Email"] = "Email";
    SessionLoginMethod["SSO"] = "SSO";
})(SessionLoginMethod || (SessionLoginMethod = {}));
export var SessionDeviceType;
(function (SessionDeviceType) {
    SessionDeviceType["Phone"] = "Phone";
    SessionDeviceType["Tablet"] = "Tablet";
    SessionDeviceType["Desktop"] = "Desktop";
})(SessionDeviceType || (SessionDeviceType = {}));
export var SessionOS;
(function (SessionOS) {
    SessionOS["iOS"] = "iOS";
    SessionOS["Android"] = "Android";
    SessionOS["MacOS"] = "MacOS";
    SessionOS["iPadOS"] = "iPadOS";
    SessionOS["ChromeOS"] = "ChromeOS";
    SessionOS["Windows"] = "Windows";
    SessionOS["Linux"] = "Linux";
})(SessionOS || (SessionOS = {}));
//# sourceMappingURL=Session.js.map